import axios from "axios";

class SignatureReceiveService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl;
  }

  /**
   * @author Alan Aguilar
   * @description Get signature request sendend by other users from Mifirma (solicitudes recibidas)
   * @date 29-07-2020
   * @param {Number} signStatusId
   * @param {String} token
   * @returns {Object}
   * @memberof
   */
  async getSignRequestsByStatus(signStatusId, token) {
    let response = await axios.get(
      `${this.apiUrl
      }/signers-by-sign-request?signStatusId=${signStatusId}&orderStatusId=${1}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  /**
   * @author Alan Aguilar
   * @description Delete a sign request by signRequestId from hibou.legal
   * @date 05-10-2020
   * @param {Number} signStatusId
   * @param {String} token
   * @returns {Object}
   * @memberof
   */
  async deleteSignRequestsById(id, comments, token) {
    let response = await axios.delete(
      `${this.apiUrl}/sign-request?id=${id}&comments=${comments}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  /**
   * @author Pedro Ramos
   * @description Get all inbox request from Govo.Legal
   * @date 06-01-2022
   * @param {Number} inboxInvolvedType
   * @param {String} token
   * @returns {Object}
   * @memberof WorkflowController
   */

  async getAllInbox(inboxInvolvedType, timezone, token) {
    let response = await axios.get(
      `${this.apiUrl}/inbox-all?inboxInvolvedType=${inboxInvolvedType}&timezone=${encodeURIComponent(timezone)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  }

  /**
   * @author Pedro Ramos
   * @description Get actions by role from Govo.Legal
   * @date 06-01-2022
   * @param {Number} inboxInvolvedType
   * @param {String} token
   * @returns {Object}
   * @memberof WorkflowController
   */

  async getActionsByRole(token) {
    let response = await axios.get(
      `${this.apiUrl}/inbox-role-actions`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  }
}

export { SignatureReceiveService as default };
